/**
 * lsmStatusMismatch — was der Mensch tun soll, wenn LSM gebucht hat und die
 * Bestellung trotzdem steht.
 *
 * @description
 *   `lsm_pog_status_mismatch` hat seit A4 (Plan 2026-11-01) einen zweiten Fall:
 *   `In Delivery` mit gebuchtem Wareneingang und vorhandener Abgleichzeile
 *   (`po_reconciliation.state` in `pending`/`confirmed`). Dort
 *   steht die Bestellung, weil die Automatik NICHT gefeuert hat — Schalter aus,
 *   Uebergang abgelehnt oder eine Datenluecke. Drei verschiedene Handlungen, und
 *   die Anzeige sagte bisher nur „still In Delivery" (Regel-16-Warnung W6).
 *
 *   🔴 **Ein Text fuer beide Flaechen, keine Kurzfassung** (Regel-16-Blocker B2
 *   der Wiedervorlage). Die erste Fassung schickte den Menschen „in den
 *   Aktivitaetsfeed" — bei `PO_AUTO_DONE_MODUS=off` schreibt `_auto_done` aber
 *   gar kein Ereignis, der Feed ist dann leer. Und auf `/ops/po-anomalies` steht
 *   der Satz allein in der Zelle, ohne Feed daneben; dort ist „mark the order
 *   Done yourself" ohne die Vorbedingung sogar falsch: der Bestandsweg
 *   ueberspringt eine Zeile ohne Preis still, und die Ware fehlt bis zur
 *   Reparatur in der Bewertung. Deshalb nennen beide Saetze die zweite Ursache
 *   und die Vorbedingung.
 *
 *   `stock_layer_missing` macht es mit `STOCK_LAYER_MISSING_NEXT_STEP` vor; das
 *   hier ist das Gegenstueck. **Bei `Order placed` und `Paid` bleibt der alte
 *   Text** — dort ist der naechste Schritt ein anderer (der Uebergang nach
 *   `In Delivery` selbst) und nicht Teil dieser Aenderung.
 *
 * @useWhen
 *   - PO-Detailseite, Anomalie `lsm_pog_status_mismatch`
 *   - Ops-Ansicht `/ops/po-anomalies`, dieselbe Anomalie
 *
 * @dontUseFor
 *   - `stock_layer_missing` — dafuer `stockLayerAnomaly.js`
 *
 * @props
 *   details — `po_anomalies.details` (`{po_status, hours_stale, lsm_state, …}`)
 */

export const LSM_MISMATCH_NEXT_STEP =
  'Goods are booked at LSM, but this order did not move to Done on its own. ' +
  'The reason is in the order\'s Activity panel, or the automatic move is ' +
  'switched off. Fix any line missing a price or product id, enter the ' +
  'quantities that actually arrived, then mark the order Done yourself.'

/** Der naechste Schritt, oder `null` fuer die alten Faelle. */
export function lsmMismatchNextStep(details) {
  const d = details && typeof details === 'object' ? details : {}
  return d.po_status === 'In Delivery' ? LSM_MISMATCH_NEXT_STEP : null
}
